import request from "@/utils/request.js";

// 获取资料清单文件
export function getFileCatalogue() {
  return request({
    method: "get",
    url: "/project/material"
  });
}

// 获取项目列表
export function getAssessList(params) {
  return request({
    method: "get",
    url: "/project/list",
    params
  });
}

// 创建项目
export function addAssess(data) {
  return request({
    method: "post",
    url: "/project/store",
    data
  });
}

// 获取专利列表
export function getPatentList(params) {
  return request({
    method: "get",
    url: "/project/patent",
    params
  });
}

// 获取项目流程
export function getHistoryList(params) {
  return request({
    url: "/project/history",
    method: "get",
    params
  });
}

// 评估转换
export function convertAssess(projectId) {
  return request({
    url: "/project/convert",
    method: "post",
    data: { projectId }
  });
}

// 获取项目资料
export function getProjectFiles(projectId) {
  return request({
    url: "/project/file",
    method: "get",
    params: { projectId }
  });
}

// 提交价值咨询资料
export const jzUploadFile = data => {
  return request({
    method: "POST",
    url: "/file/store_jz",
    data
  });
};

// 保存价值咨询资料
export const jzSaveFile = data => {
  return request({
    method: "POST",
    url: "/file/upload_jz",
    data
  });
};

// 提交预评估资料
export const ypUploadFile = data => {
  return request({
    method: "POST",
    url: "/file/store_yp",
    data
  });
};

// 保存预评估资料
export const ypSaveFile = data => {
  return request({
    method: "POST",
    url: "/file/upload_yp",
    data
  });
};

// 提交正式评估资料
export const zsUploadFile = data => {
  return request({
    method: "POST",
    url: "/file/store_zs",
    data
  });
};

// 保存正式评估资料
export const zsSaveFile = data => {
  return request({
    method: "POST",
    url: "/file/upload_zs",
    data
  });
};
